var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { width: "20px", height: "20px" },
      attrs: { id: "MediumIcon" },
    },
    [
      _c(
        "svg",
        {
          staticStyle: { "enable-background": "new 0 0 16 16" },
          attrs: {
            version: "1.1",
            id: "Warstwa_1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            x: "0px",
            y: "0px",
            viewBox: "0 0 16 16",
            "xml:space": "preserve",
          },
        },
        [
          _c("g", { attrs: { id: "icon_x2F_16px_x2F_medium-priority-" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st0",
                attrs: {
                  d: "M3,4h10c0.6,0,1,0.4,1,1s-0.4,1-1,1H3C2.4,6,2,5.6,2,5S2.4,4,3,4z M3,10h10c0.6,0,1,0.4,1,1s-0.4,1-1,1H3\n\t\t\tc-0.6,0-1-0.4-1-1S2.4,10,3,10z",
                },
              }),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }